import { useState } from "react";
import { useErrorHandler } from "./useErrorHandler";
import * as Yup from "yup";
import { useLayoutStore } from "../store/layout.store";
import { meterSchema } from "../schemas/meter.schema";
import { useRegisterStore } from "../store/register.store";
import { successToastHook } from "../components/toasts/success";
import { createMeterAsync } from "../actions/meters.actions";

export const useMeters = () => {
  const { handleError } = useErrorHandler();
  const { setAsideBarOpened } = useLayoutStore((state) => state);

  const useAddEditMeter = (id?: string) => {
    const properties = useRegisterStore((state) => state.allProperties);
    const [loading, setLoading] = useState(false);

    const submitData = ({
      values,
      onSuccess,
    }: {
      values: Yup.InferType<typeof meterSchema>;
      onSuccess?: () => void;
    }) => {
      setLoading(true);

      if (!id) {
        createMeterAsync({
          values: values,
        })
          .then((res) => {
            setLoading(false);

            successToastHook({ msg: "Meter added successfully!!" });

            setTimeout(() => {
              if (onSuccess) {
                onSuccess();
              }

              setAsideBarOpened(false);
            }, 1000);
          })
          .catch((error) => {
            setLoading(false);

            handleError(error);
          });
      }
    };

    return {
      submitData,
      loading,
      propertySelectData: properties?.map((property) => ({
        label: property.propertyName,
        value: property.id,
      })),
    };
  };

  const onCancel = ({ action }: { action?: () => void }) => {
    setAsideBarOpened(false);

    if (action) {
      action();
    }
  };

  return {
    useAddEditMeter,
    onCancel,
  };
};
